import { Component, Inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserApi } from '@lkp/parking-sdk';
import { USER_API } from '../../core/providers/api.module';
import { Subject, takeUntil } from 'rxjs';
import { AuthenticationService } from 'src/app/core/services/authentication.service';

const matchingFieldsValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const firstPass = control.get('newPass');
  const secondPass = control.get('repeatPass');

  return firstPass && secondPass && firstPass.value !== secondPass.value
    ? { noMatchPass: true }
    : null;
};

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    standalone: false
})
export class ResetPasswordComponent implements OnInit {
  public resetToken: string = '';
  validToken = true;
  newPassForm?: FormGroup;
  message?: string = undefined;
  resetFinished = false;
  readonly onDestroy$ = new Subject<void>();

  constructor(
    readonly route: ActivatedRoute,
    @Inject(USER_API) readonly userApi: UserApi,
    readonly router: Router,
    readonly authenticationService: AuthenticationService
  ) {
    this.authenticationService.logout(false);
    this.resetToken = this.route.snapshot.paramMap.get('token')!;
    this.userApi
      .passwordResetRequestValidation({
        passwordResetRequestTransferDTO: { resetToken: this.resetToken },
      })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((res) => {
        this.validToken = res;
      });
  }

  ngOnInit(): void {
    this.message = undefined;
    this.newPassForm = new FormGroup(
      {
        newPass: new FormControl('', Validators.required),
        repeatPass: new FormControl('', Validators.required),
      },
      { validators: matchingFieldsValidator }
    );
  }

  submit() {
    this.message = undefined;
    this.userApi
      .resetPasswordAdmin({
        passwordResetRequestTransferDTO: {
          resetToken: this.resetToken,
          newPassword: this.newPassForm?.value.newPass,
        },
      })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: () => {
          this.message = 'Lösenord återställt!';
          this.resetFinished = true;
        },
        error: () => {
          console.error('Error resetting password');
          this.message =
            'Det gick inte att återställa lösenordet. Kontrollera uppgifterna eller prova igen.';
        },
      });
  }

  toLogin() {
    this.router.navigate(['../login']);
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
